import { NgClass } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-help-open-icon',
  imports: [NgClass],
  templateUrl: './help-open-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './help-open-icon.component.scss',
})
export class HelpOpenIconComponent {
  @Input() public isOpen = false;
}
